import deductionsList from './deductions-list';
import paymentsList from './payments-list';
import list from './list';
import create from './create';
import update from './update';
import show from './show'
import del from './delete';

export default {
  namespaced: true,
  modules: {
    deductionsList,
    paymentsList,
    list,
    create,
    update,
    show,
    del
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/factoredinvoice/index.js